module.exports = __webpack_public_path__ + "static/media/cozy9101.5bc9cd02.jpg";